module.exports = __webpack_public_path__ + "static/media/servImg5.df602a32.svg";